import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_SURVEY_URL = process.env.REACT_APP_SURVEY_URL;

// Hydration-safe: initial render (both react-snap prerender and browser
// first paint) MUST return the same value or React 19 throws #418 and
// tears down the DOM to re-render — producing a visible flash on slow
// devices. We therefore return the base URL synchronously and only
// append the caller's incoming query params (utm_*, ad ids, etc.) in a
// useEffect after hydration completes.
export function useSurveyUrl() {
  const { search } = useLocation();
  const [url, setUrl] = useState(BASE_SURVEY_URL);
  useEffect(() => {
    if (!search) {
      setUrl(BASE_SURVEY_URL);
      return;
    }
    const params = new URLSearchParams(search);
    const str = params.toString();
    setUrl(str ? `${BASE_SURVEY_URL}?${str}` : BASE_SURVEY_URL);
  }, [search]);
  return url;
}
